// src/utils/csvExport.js
//
// 纯前端生成CSV并下载，不需要额外的后端接口——数据已经在页面里加载好了，
// 直接在浏览器里转换成CSV格式的文本，做成一个Blob触发下载即可。
// 加了UTF-8 BOM前缀，是为了Excel打开中文CSV文件不会显示成乱码
// （Excel默认按系统编码猜测文件编码，不加BOM，中文在Excel里经常会乱码）。

/**
 * @param {Array<Object>} rows - 要导出的数据
 * @param {Array<{key: string, label: string}>} columns - 列定义，key对应rows里的字段名，label是表头显示文字
 * @param {string} filename - 下载的文件名（不用带.csv后缀，会自动加）
 */
export function exportToCSV(rows, columns, filename) {
  const header = columns.map(c => `"${c.label}"`).join(',');
  const body = rows.map(row =>
    columns.map(c => {
      const val = row[c.key];
      if (val == null) return '""';
      // 值本身如果带双引号，要转义成两个双引号，这是CSV格式的标准转义方式
      return `"${String(val).replace(/"/g, '""')}"`;
    }).join(',')
  ).join('\n');

  const csvContent = '\uFEFF' + header + '\n' + body; // \uFEFF 是 UTF-8 BOM
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const dateStr = new Date().toISOString().slice(0, 10);
  link.download = `${filename}_${dateStr}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}